<template>
    <div class="container">
        <!-- 查询表单 -->
        <el-form :inline="true" :model="searchList" class="demo-form-inline" label-width="100px">
            <el-form-item>
                <el-button type="success" @click="toAdd()">新增信息</el-button>
                <el-button type="primary" @click="exportExcel()">下载表格</el-button>
            </el-form-item>
            <br />
            <el-form-item label="下单时间：">
                <el-form-item>
                    <el-date-picker
                        v-model="searchList.ordertime"
                        type="daterange"
                        value-format="yyyy/M/d"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
            </el-form-item>
            <el-form-item label="到期日期：">
                <el-form-item>
                    <el-date-picker
                        v-model="searchList.expirydate"
                        type="daterange"
                        value-format="yyyy/M/d"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
            </el-form-item>
            <br>
            <el-form-item label="续费次数：">
                <el-input v-model="searchList.paynum" placeholder="续费次数" clearable></el-input>
            </el-form-item>
            <el-form-item label="订单状态：">
                <el-select v-model="searchList.compstatus">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="首次购买" value="1"></el-option>
                    <el-option label="续费" value="2"></el-option>
                    <el-option label="升级" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="负责人：">
                <el-input v-model="searchList.owner" placeholder="负责人" clearable></el-input>
            </el-form-item>
            <el-form-item label="UID：">
                <el-input v-model="searchList.uid" placeholder="UID" clearable></el-input>
            </el-form-item>
            <el-form-item label="邮箱：">
                <el-input v-model="searchList.account" placeholder="邮箱" clearable></el-input>
            </el-form-item> 
            <el-form-item label="用户名称：">
                <el-input v-model="searchList.username" placeholder="用户名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="支付方式：">
                <el-select v-model="searchList.paytype">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="支付宝_铁脚印" value="zfb-tjy"></el-option>
                    <el-option label="支付宝_铁脚印_手动" value="zfb-tjy-ht"></el-option>
                    <el-option label="支付宝_满天星" value="zfb-mtx"></el-option>
                    <el-option label="微信_姚娟" value="wx-yao"></el-option>
                    <el-option label="比特币1" value="btc"></el-option>
                    <el-option label="比特币2" value="btc2"></el-option>
                    <el-option label="比特币3" value="btc3"></el-option>
                    <el-option label="PayPal_Rainbow" value="pp-rb"></el-option>
                    <el-option label="PayPal_Revenuelook" value="pp-rl"></el-option>
                    <el-option label="Stripe_Rainbow" value="cc-rb"></el-option>
                    <el-option label="Payssion" value="ps-rl"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="联系方式：">
                <el-input v-model="searchList.contact" placeholder="联系方式" clearable></el-input>
            </el-form-item>
            <el-form-item label="是否待处理：">
                <el-select v-model="searchList.ispending">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="待处理" value="1"></el-option>
                    <el-option label="已处理" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="账号状态：">
                <el-select v-model="searchList.banstatus">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="封号" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-left: 1vw">
                <el-button type="primary" @click="search()">查询</el-button>
            </el-form-item>
        </el-form>
        <p>
            汇总：&nbsp;&nbsp;&nbsp;人民币总额（元）：<strong>{{ rmb }}</strong> 美元总额（不包含比特币）：<strong>{{ usd }}</strong>
            比特币总额（美元）：<strong>{{ btc }}</strong> 手续费总额（美元）：<strong>{{ com }}</strong>
        </p>
        <!-- 表格 -->
        <el-table
            :data="list.slice((currentPage - 1) * pagesize, currentPage * pagesize)"
            style="width: 100%"
            height="650"
            border
            id="out-table">
            <el-table-column label="下单时间" width="100" fixed="left">
                <template slot-scope="scope">
                    <span>{{ scope.row.ordertime }}</span>
                </template>
            </el-table-column>
            <el-table-column label="用户ID" width="80" fixed="left">
                <template slot-scope="scope">
                    <span>{{ scope.row.uid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="邮箱" width="220">
                <template slot-scope="scope">
                    <span>{{ scope.row.account }}</span>
                </template>
            </el-table-column>
            <el-table-column label="支付方式" width="180">
                <template slot-scope="scope">
                    <span v-if="scope.row.paytype == 'zfb-tjy'">支付宝_铁脚印（元）</span>
                    <span v-else-if="scope.row.paytype == 'zfb-tjy-ht'">支付宝_铁脚印_手动（元）</span>
                    <span v-else-if="scope.row.paytype == 'zfb-mtx'">支付宝_满天星（元）</span>
                    <span v-else-if="scope.row.paytype == 'wx-yao'">微信_姚娟（元）</span>
                    <span v-else-if="scope.row.paytype == 'btc'">比特币1（美元）</span>
                    <span v-else-if="scope.row.paytype == 'btc2'">比特币2（美元）</span>
                    <span v-else-if="scope.row.paytype == 'btc3'">比特币3（美元）</span>
                    <span v-else-if="scope.row.paytype == 'pp-rl'">PayPal_RL（美元）</span>
                    <span v-else-if="scope.row.paytype == 'pp-rb'">PayPal_RB（美元）</span>
                    <span v-else-if="scope.row.paytype == 'cc-rb'">Stripe_RB（美元）</span>
                    <span v-else-if="scope.row.paytype == 'ps-rl'">Payssion（美元）</span>
                </template>
            </el-table-column>
            <el-table-column label="金额">
                <template slot-scope="scope">
                    <span>{{ scope.row.money }}</span>
                </template>
            </el-table-column>
            <el-table-column label="手续费">
                <template slot-scope="{row}">
                    <span v-if="!row.edit">{{row.commission }}</span>
                    <el-input v-else v-model="row.commission"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="实际到账">
                <template slot-scope="scope">
                    <span>{{ scope.row.income }}</span>
                </template>
            </el-table-column>
            <el-table-column label="到期日期" width="120">
                <template slot-scope="{row}">
                    <span v-if="!row.edit">{{ row.expirydate }}</span>
                    <el-input v-else v-model="row.expirydate"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="负责人" width="80">
                <template slot-scope="{row}">
                    <span v-if="!row.edit">{{ row.owner }}</span>
                    <el-input v-else v-model="row.owner"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="渠道来源">
                <template slot-scope="scope">
                    <span v-if="scope.row.refer == 'htdata'">官方</span>
                    <span v-else-if="scope.row.refer == 'baidu'">百度</span>
                    <span v-else-if="scope.row.refer == '360'"></span>
                    <span v-else-if="scope.row.refer == 'sogo'">搜狗</span>
                    <span v-else-if="scope.row.refer == 'person'">用户推广</span>
                </template>
            </el-table-column>
            <el-table-column label="联系方式">
                <template slot-scope="{row}">
                    <span v-if="!row.edit">{{ row.contact }}</span>
                    <el-input v-else v-model="row.contact"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="用户名称">
                <template slot-scope="{row}">
                    <span v-if="!row.edit">{{ row.username }}</span>
                    <el-input v-else v-model="row.username"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="套餐备注" width="220">
                <template slot-scope="{row}">
                    <span v-if="!row.edit">{{ row.remark }}</span>
                    <el-input v-else v-model="row.remark"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="售后备注" width="160">
                <template slot-scope="{row}">
                    <span v-if="!row.edit">{{ row.remark2 }}</span>
                    <el-input v-else v-model="row.remark2"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="续费次数" width="80">
                <template slot-scope="{row}">
                    <span v-if="!row.edit">{{ row.paynum }}</span>
                    <el-input type="number" v-else v-model="row.paynum"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="是否待处理" width="130">
                <template slot-scope="{row}">
                    <span v-if="row.ispending == 1" v-show="!row.edit">待处理</span>
                    <span v-else v-show="!row.edit">已处理</span>
                    <el-radio-group v-model="row.ispending" v-show="row.edit">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="2">否</el-radio>
                    </el-radio-group>
                </template>
            </el-table-column>
            <el-table-column label="账号状态" width="160">
                <template slot-scope="{row}">
                    <span v-if="row.banstatus == 1" v-show="!row.edit">正常</span>
                    <span v-else v-show="!row.edit">封号</span>
                    <el-radio-group v-model="row.banstatus" v-show="row.edit">
                        <el-radio label="1">正常</el-radio>
                        <el-radio label="2">封号</el-radio>
                    </el-radio-group>
                </template>
            </el-table-column>
            <el-table-column label="订单状态" width="300">
                <template slot-scope="{row}">
                    <span v-if="row.compstatus == 1" v-show="!row.edit">首次购买</span>
                    <span v-else-if="row.compstatus == 2" v-show="!row.edit">续费</span>
                    <span v-else-if="row.compstatus == 3" v-show="!row.edit">升级</span>
                    <el-radio-group v-model="row.compstatus" v-show="row.edit">
                        <el-radio label="1">首次购买</el-radio>
                        <el-radio label="2">续费</el-radio>
                        <el-radio label="3">升级</el-radio>
                    </el-radio-group>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200" fixed="right">
                <template slot-scope="{row}">
                    <el-button size="mini" @click="edit(row)" type="primary" v-if="!row.edit">编辑</el-button>
                    <el-button size="mini" @click="handleEdit(row)" type="primary" v-else>保存</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(row)" v-if="!row.edit">删除</el-button>
                    <el-button size="mini" type="danger" @click="cancel(row)"  v-else>取消</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50]"
                :page-size="pagesize"
                layout="total,sizes,prev, pager, next"
                :total="list.length"
                prev-text="上一页"
                next-text="下一页"
                background>
            </el-pagination>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
export default {
    data() {
        return {
            //搜索列表
            searchList: {
                ordertime: '',
                owner:'',
                uid: '',
                account: '',
                paytype: '',
                expirydate: '',
                contact: '',
                username: '',
                remark: '',
                ispending: '',
                banstatus: ''
            },
            rmb: '',  //人民币总额
            usd: '', //美金总额
            btc: '', //比特币总额
            com: '', //手续费总额
            list: [], //表格所有数据
            currentPage: 1, //默认显示页面为第一页
            pagesize: 10 //每页的数据条数
        };
    },
    created() {
        this.getList();
    },
    methods: {
        //获取表格所有数据
        async getList() {
            const res = await axios.post(
                'https://admin.vmlogin.com.cn/api/orders.php',
                qs.stringify({ ...this.searchList, ...{ op: 'list' } })
            );
            if (res.data.code === 200) {
                this.rmb = res.data.totalMoney.rmb;
                this.usd = res.data.totalMoney.usd;
                this.btc = res.data.totalMoney.btc;
                this.com = res.data.totalMoney.commission;
                let items = res.data.data
                this.list = items.map(v=>{
                    this.$set(v,'edit',false)
                    v.orginalCommission = v.commission
                    v.orginalExpirydate = v.expirydate
                    v.orginalContact = v.contact
                    v.orginalUsername = v.username
                    v.orginalRemark = v.remark
                    v.orginalRemark2 = v.remark2
                    v.orginalPaynum = v.paynum
                    v.orginalIspending = v.ispending
                    v.orginalBanstatus = v.banstatus
                    v.orginalCompstatus = v.compstatus
                    v.orginalOwner = v.owner
                    return v
                })
            }else{
                this.$message.error(res.data.msg)
            }
        },
        //改变每页显示数量
        handleSizeChange(size) {
            this.pagesize = size;
        },
        //点击第几页
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
        },

        //查询
        search() {
            this.currentPage = 1
            this.getList()
        },

        //删除内容
        handleDelete(row) {
            this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                    axios.post("https://admin.vmlogin.com.cn/api/orders.php",
                        qs.stringify({ op: 'delete', id: row.id })
                    ).then(res=>{
                        if(res.data.code === 200){
                            this.$message.error("删除成功")
                            this.getList();
                        }else{
                            this.$message.error("Something width wrong...")
                        }
                    })
            }).catch(() => {});
        },
        //跳转到新增页面
        toAdd() {
            this.$router.push('/add');
        },
        //编辑
        edit(row) {
            row.edit =!row.edit
        },
        //保存编辑
        async handleEdit(row) {
            const res = await axios.post(
                'https://admin.vmlogin.com.cn/api/orders.php',
                qs.stringify({ ...row, ...{ op: 'add' }, ...{ id: row.id } })
            );
            if (res.data.code === 200) {
                row.edit = false
                row.orginalCommission = row.commission
                row.orginalExpirydate =row.expirydate
                row.orginalContact = row.contact
                row.orginalUsername = row.username
                row.orginalRemark = row.remark
                row.orginalRemark2 = row.remark2
                row.orginalPaynum = row.paynum
                row.orginalIspending = row.ispending
                row.orginalBanstatus = row.banstatus
                row.orginalCompstatus = row.compstatus
                row.orginalOwner = row.owner
            }else{
                this.$message.error(res.data.msg)
            }
        },
        //取消编辑
        cancel(row) {
            row.commission = row.orginalCommission
            row.expirydate = row.orginalExpirydate
            row.contact = row.orginalContact
            row.username = row.orginalUsername
            row.remark = row.orginalRemark
            row.remark2 = row.orginalRemark2
            row.paynum = row.orginalPaynum
            row.ispending = row.orginalIspending
            row.banstatus = row.orginalBanstatus
            row.compstatus = row.orginalCompstatus
            row.owner = row.orginalOwner
            row.edit = false
        },
        //导出excel表格
        exportExcel() {
            import('../../excel/export2Excel').then((excel) => {
                const tHeader = ['下单时间', '用户ID',"邮箱","支付方式","金额","手续费","实际到账","到期日期"];
                const filterVal = ['ordertime','uid', 'account','paytype2','money','commission','income','expirydate'];
                const list = this.list;
                const data = this.formatJson(filterVal, list);
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: 'table-list'
                });
                this.downloadLoading = false;
            });
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) =>
                filterVal.map((j) => {
                    if (j === 'timestamp') {
                        return parseTime(v[j]);
                    } else {
                        return v[j];
                    }
                })
            );
        }
    }
};
</script>

<style lang="less" scoped>
.container {
    p {
        line-height: 1rem;
        padding: 1rem 0;
        font-size: 14px;
        strong {
            color: red;
            margin-right: 2vw;
        }
    }
    /deep/.el-table .cell {
        text-align: center;
    }
    /deep/ .el-table {
        flex: auto;
    }
    /deep/ .el-date-editor .el-range-separator {
        padding: 0;
    }
    .pagination {
        padding-top: 2rem;
        text-align: center;
    }
    /deep/ .el-form-item__label {
        padding: 0 5px 0 0;
        margin-left: 5px;
    }
    /deep/ .el-radio-button__inner,
    .el-radio-group {
        line-height: normal;
        vertical-align: baseline;
    }
}
</style>